<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-skeleton :row="20" :loading="loading">
      <div v-if="data" class="TopImage">
        <van-swipe :autoplay="3000">
          <van-swipe-item v-for="(image, index) in img" :key="index">
            <van-image
              width="100vw"
              height="56.25vw"
              lazy-load
              fit="cover"
              :src="image"
            />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div v-if="data" class="baseRect breakAll">
        <div class="title">
          基本信息
        </div>
        <div class="titleSmall" :style="'color:'+GetDiveMainBack()">
          BASE INFORMATION
        </div>
        <div class="dataRect">
          <van-row v-for="(item,index) in attribute" :key="index">
            <van-col span="8" class="Property">{{ item.title }}</van-col>
            <van-col span="16">{{ showValue(item.about) }}</van-col>
          </van-row>
        </div>
      </div>
      <div v-if="data && data.visibilityType" class="baseRect">
        <div class="title">
          观赏说明
        </div>
        <div class="titleSmall" :style="'color:'+GetDiveMainBack()">
          APPRECIATION
        </div>
        <div class="dataRect">
          <van-row>
            <van-col span="8" class="Property">潜点</van-col>
            <van-col span="16">{{ showValue(data.placeName) }} {{ data.placeNameEng }}</van-col>
          </van-row>
          <van-row>
            <van-col span="8" class="Property">易见性</van-col>
            <van-col span="16">{{ GetEnumText('Em_VisibilityType',data.visibilityType) }}</van-col>
          </van-row>
          <van-row>
            <van-col span="8" class="Property">最佳观赏时间</van-col>
            <van-col span="16">
              {{ showValue(bestMonthStr) }}月
            </van-col>
          </van-row>
          <van-row>
            <van-col span="8" class="Property">补充说明</van-col>
            <van-col span="16">{{ showValue(data.about) }}</van-col>
          </van-row>
          <van-row v-if="data.divePlaceList.length>1">
            <van-col span="8" class="Property">其他潜点</van-col>
            <van-col span="16">
              <div v-for="item in data.divePlaceList" :key="item.divePlaceId">
                <van-tag v-if="item.relationId !==data.fishPlaceRelationId" :color="GetDiveMainBack()" class="tagDivePoing" round @click="onOtherPlace(item.relationId)">
                  {{ item.placeName }} {{ item.placeNameEng }}
                </van-tag>
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <div v-if="data" class="baseRect breakAll">
        <div class="title">
          简介
        </div>
        <div class="titleSmall" :style="'color:'+GetDiveMainBack()">
          PROFILE
        </div>
        <div class="dataRect">
          {{ data.biology.about }}
        </div>
      </div>
      <div v-for="(item,index) in details" :key="index" class="baseRect breakAll">
        <div class="title">
          {{ item.title }}
        </div>
        <div class="titleSmall" :style="'color:'+GetDiveMainBack()">
          INFORMATION - {{ index+1 }}
        </div>
        <div class="dataRect">
          {{ item.about }}
        </div>
      </div>
      <div v-if="GetEnbaleDiveComment()" class="baseRect">
        <div class="title">
          点评
          <div style="float:right" @click="showAddComment=true"><i class="iconfont iconadd" /></div>
        </div>
        <div class="titleSmall" :style="'color:'+GetDiveMainBack()">
          REVIEWS
        </div>
        <diveCommentList v-model="commentId" :comment-type="commentType" />
        <diveCommentAdd v-model="showAddComment" :comment-id="commentId" :comment-type="commentType" />
      </div>
    </van-skeleton>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Skeleton, Image, Lazyload, Swipe, SwipeItem, Tag, Rate } from 'vant'
import TopBar from '@/components/TopBar'
import { showValue, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetEnbaleDiveComment, GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
import diveCommentList from '@/components/diveCommentList'
import diveCommentAdd from '@/components/diveCommentAdd'

export default {
  components: {
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    [Image.name]: Image,
    [Lazyload.name]: Lazyload,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Tag.name]: Tag,
    [Rate.name]: Rate,
    TopBar,
    diveCommentAdd,
    diveCommentList
  },
  data() {
    return {
      titleTop: '',
      title: '',
      backurl: '/dive',
      loading: true,
      id: undefined,
      data: undefined,
      img: [],
      attribute: undefined,
      details: undefined,
      bestMonth: [],
      bestMonthStr: undefined,
      commentId: undefined,
      commentType: undefined,
      showAddComment: false
    }
  },

  created() {
    this.titleTop = GetDiveTitle()
    this.id = this.$route.params.id
    this.init()
  },
  methods: {
    GetEnbaleDiveComment,
    showValue,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    sortNumber(a, b) {
      return a - b
    },
    init() {
      request({
        url: '/DiveData/getBiology',
        method: 'post',
        params: { id: this.id }
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        this.data = response.data
        this.title = this.data.biology.name
        if (this.data.biology.attribute) {
          this.attribute = JSON.parse(this.data.biology.attribute)
          // console.log('attribute', this.attribute)
        }
        if (this.data.biology.attribute) {
          this.details = JSON.parse(this.data.biology.details)
          // console.log('details', this.details)
        }
        if (!this.title) {
          this.title = '生物'
        }
        if (this.data.biology.imgs) {
          this.img = this.data.biology.imgs.split(',')
        } else {
          this.img = ['/dive/defaultFish.jpg']
        }
        if (this.data.bestMonth) {
          var list = this.data.bestMonth.split(',')
          this.bestMonth = []
          list.forEach(item => {
            this.bestMonth.push(Number(item))
          })
          this.bestMonth = this.bestMonth.sort(this.sortNumber)
          console.log('bestMonth', this.bestMonth)
        } else {
          this.bestMonth = []
        }
        this.bestMonthStr = this.bestMonth.join('、')
        setTimeout(() => {
          this.commentType = 'Fish'
          this.commentId = this.id
        }, 1)
      })
    },
    onOtherPlace(id) {
      this.id = id
      // this.$router.push('/dive/biology/' + id)
      this.data = undefined
      this.loading = true
      this.init()
    }
  }
}
</script>
<style scoped>
.TopImage{
    background-color: #fff;
}
.baseRect{
    background-color: #fff;
    margin-bottom: 0.5em;
    padding: 1em;

}

.baseRect .title
{
    font-weight: 700;
}
.baseRect .titleSmall{
    font-size: 0.8em;
    font-weight: 700;
    padding-top: 0.25em;
    padding-bottom: 0.5em;
}
.baseRect .dataRect{
    color: #999;
    font-size: 0.9em;

}
.baseRect .Property{
    color: #000;
}
.tagDivePoing{
    margin-bottom: 0.5em;
    padding: 0.5em 1em;
}

.comment{
    position: relative;
    border-bottom: 1px solid #f5f5f5;
    margin-bottom: 0.5em;
}
.comment .icon{
    position: absolute;
    left: 0.5em;
    top: 0;
    width: 4em;
}
.comment .Body{
    padding-left: 5em;
}
.comment .Body span{
    font-weight: 700;
    font-size: 0.9em;
}
.comment .Body div{
    padding: 0.25em 0;
    font-size: 0.8em;
    color: #999;
}
.comment .Body .img{
    margin:0.5em 0.5em 0 0;
    overflow: hidden;
}
</style>
